/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
import { useCallback, useEffect, useRef, useState } from 'react';
import { GetStaticProps } from 'next';
import api from '@/services/api';
import Loading from '@/components/Loading';
import {
  WrapperBlog,
  NoResults,
  ContainerSearch,
  Category
} from '@/styles/pages/blog';
import ActiveCampaignForm from '@/components/ActiveCampaignForm';
import { Container } from '@/styles/pages';
import Post from '@/components/Post';
import SearchInput from '@/components/SearchInput';
import PostModel from '@/models/post';
import { Button } from '@/components/Button/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import NavCategory from '@/components/NavCategory';
import { css } from 'styled-components';
import { gaSendEvent } from '@/models/gaEvent';
import { useRouter } from 'next/router';
import SideNav from '@/components/SideNav';

interface PostsProps {
  posts: PostModel[];
}

const Posts: React.FC<PostsProps> = ({ posts }) => {
  const {
    query: { search }
  } = useRouter();

  const [filteredPosts, setFilteredPosts] = useState<PostModel[]>(() => {
    return search ? [] : posts;
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(false);
  const [morePostsloading, setMorePostsLoading] = useState<boolean>(false);
  const [noMorePosts, setNoMorePosts] = useState<boolean>(false);

  const [page, setPage] = useState<number>(2);
  const [categories, setCategories] = useState([]);
  const [recommended, setRecommended] = useState([]);

  const loadMoreRef = useRef(null);

  useEffect(() => {
    const getPosts = async () => {
      try {
        const { data } = await api.get('/posts', {
          params: {
            per_page: 3,
            _embed: 0
          }
        });
        setRecommended(data);
      } catch (e) {
        console.log(e);
      }
    };

    getPosts();
  }, []);

  const getCategories = useCallback(async () => {
    try {
      const { data } = await api.get('/categories', {
        params: {
          per_page: 5
        }
      });

      setCategories(data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getCategories();
  }, []);

  const getPostsBySearch = useCallback(
    async (_search) => {
      try {
        setLoading(true);

        const { data } = await api.get('/posts', {
          params: {
            search: _search,
            _embed: 1,
            per_page: 10,
            page: 1
          }
        });

        setFilteredPosts(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    },
    [page]
  );

  useEffect(() => {
    if (search) getPostsBySearch(search);
  }, [search]);

  useEffect(() => {
    const getMorePosts = async (_page) => {
      setPage(_page);
      try {
        setMorePostsLoading(true);
        const { data } = await api.get('/posts', {
          params: {
            _embed: 1,
            search,
            per_page: 10,
            page: _page
          }
        });

        setFilteredPosts((_data) => [..._data, ...data]);
        setMorePostsLoading(false);
      } catch (error) {
        setMorePostsLoading(false);
        setNoMorePosts(true);
      }
    };

    getMorePosts(page);
  }, [page]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0
    };

    const observer = new IntersectionObserver((entities) => {
      const target = entities[0];

      if (target.isIntersecting) {
        setPage((page) => page + 1);
      }
    }, options);

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
  }, []);


  return (
    <>
      <Head>
        <title>Cloudez Blog</title>
        <meta
          name="description"
          property="og:description"
          content="Alta performance para sites e estratégias de crescimento para agências, esteja sempre atualizado com o blog da Cloudez."
        />

        <meta
          property="og:image"
          content="https://i.ibb.co/3dt8kq9/meta-blog.png"
        />
      </Head>

      <SideNav search={search} />

      {categoryLoading || loading ? (
        <Loading />
      ) : search ? (
        <>
          <NoResults>
            <ContainerSearch>
              <div className="container-result">
                <div className="steps_result">
                  <a style={{ marginRight: '7px' }} href="/br/blog">
                    <Image
                      priority
                      src="/home.png"
                      width={13}
                      height={13}
                      alt="home"
                    />
                  </a>
                  <Image
                    priority
                    src="/arrow-right.png"
                    width={8}
                    height={16}
                    alt="arrow"
                  />
                  <div style={{ marginLeft: '0.5rem' }}>Pesquisa</div>
                </div>
                <div className="title_result">
                  <h1>
                    Exibindo
                    <strong>{filteredPosts.length}</strong>
                    resultados para
                    <strong>“{search}”</strong>
                  </h1>
                </div>

                {filteredPosts.map((posts) => {
                  let excerptCategory = posts.excerpt.rendered;
                  if (excerptCategory.length > 95) {
                    excerptCategory = `${excerptCategory.substring(0, 95)}...`;
                  }
                  let titleCategory = posts.title.rendered;
                  if (titleCategory.length > 50) {
                    titleCategory = `${titleCategory.substring(0, 50)}...`;
                  }

                  return (
                    <div key={posts.slug} className="posts-content_result">
                      <a href={`/br/blog/${posts.slug}`}>
                        <Image
                          priority
                          src={
                            posts._embedded?.['wp:featuredmedia'][0]?.source_url
                          }
                          width="380px"
                          height="292.78px"
                          alt={
                            posts._embedded?.['wp:featuredmedia'][0]?.alt_text
                          }
                          objectFit="cover"
                        />
                      </a>
                      <div className="category-information_result">
                        <h3>{posts._embedded?.['wp:term'][0][0]?.name}</h3>

                        <a href={`/br/blog/${posts.slug}`}>
                          <h2
                            dangerouslySetInnerHTML={{
                              __html: titleCategory
                            }}
                          />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: excerptCategory
                            }}
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}

                <Button
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    color: '#2253f5',
                    borderColor: '#2253f5'
                  }}
                  onClick={
                    () => {
                      setPage((page) => page + 1);
                    }
                  }
                  disabled={noMorePosts}
                >
                  {morePostsloading ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : noMorePosts ? (
                    'Sem mais posts'
                  ) : (
                    'Carregar mais'
                  )}
                </Button>

                <section className="section-posts">
                  <div className="title-recommended">
                    <h1>recomendados</h1>
                  </div>
                  <div className="post">
                    {recommended.map((post) => {
                      let excerptTwoCategory = post.excerpt.rendered;
                      if (excerptTwoCategory.length > 95) {
                        excerptTwoCategory = `${excerptTwoCategory.substring(
                          0,
                          95
                        )}...`;
                      }
                      let titleTwoCategory = post.title.rendered;
                      if (titleTwoCategory.length > 50) {
                        titleTwoCategory = `${titleTwoCategory.substring(
                          0,
                          50
                        )}...`;
                      }
                      return (
                        <div className="cardblog" key={post.slug}>
                          <a href={`/br/blog/${post.slug}`}>
                            <Image
                              priority
                              src={
                                post._embedded?.['wp:featuredmedia'][0]
                                  ?.source_url
                              }
                              width="330px"
                              height="271px"
                              alt={
                                post._embedded?.['wp:featuredmedia'][0]?.alt_text
                              }
                            />
                          </a>
                          <div className="card_items">
                            <h3>
                              <Link
                                href={`/br/blog/categoria/${post._embedded?.['wp:term'][0][0]?.slug}`}
                              >
                                {post._embedded?.['wp:term'][0][0]?.name}
                              </Link>
                            </h3>

                            <a href={`/br/blog/${post.slug}`}>
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: titleTwoCategory
                                }}
                              />
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: excerptTwoCategory
                                }}
                              />
                              <p />
                            </a>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </section>
              </div>
            </ContainerSearch>
          </NoResults>
        </>
      ) : (
        <>
          <Container>
            {filteredPosts?.map((post: PostModel, i) => {
              if (i === 0) {
                return <Post post={post} key={post.id} first />;
              }
            })}
          </Container>

          <Container>
            {filteredPosts?.map((post: PostModel, i) => {
              if (i > 0 && i <= 3) {
                return <Post post={post} key={post.id} />;
              }
            })}
          </Container>

          <WrapperBlog>
            <div className="container">
              <div className='cta-text' style={{
                width: "50%",
                display: 'flex',
                justifyContent: 'center',
              }}>
                <div className="webinar-info">
                  <span>Webinar gratuito</span>
                  <h1>Tech SEO para agências digitais</h1>
                  <p className='light'>A importância de alta performance para sites que geram resultados</p>
                  <p className='heavy'>Dia 07 de Junho de 2022, às 19h, ao vivo</p>
                  <button onClick={
                    () => {
                      window.open("https://content.cloudez.io/webinar-tech-seo-agencias-digitais?utm_campaign=blog-webinar_techseo-visitantes&utm_medium=&utm_source=blog&utm_content=&utm_term=", "_blank")
                    }
                  }>
                    Inscreva-se gratuitamente
                  </button>
                </div>
              </div>
              <div className='cta-image' style={{
                width: "50%",
                display: 'flex',
                justifyContent: 'center',
              }}>
                <Image
                  priority
                  src="/img-cta.png"
                  width={460}
                  height={489}
                  alt="arrow"
                />
              </div>
              {/* <div className="imageContainer">
                <img src="/premissasCTA.png" alt="CTA Premissas" />
              </div>
              <div className="textContainer">
                <span className="title">
                  Kit Premissas para agências digitais
                </span>
                <h1 className="midText">
                  Mais resultados para sua <br /> <i>agência digital</i>
                </h1>
                <a
                  href="https://content.cloudez.io/premissas-estrategicas-para-agenciais-digitais?utm_campaign=blog-kit_premissas-visitantes_cta_home&utm_medium=&utm_source=blog&utm_content=&utm_term="
                  className="downloadKit"
                  target="_blank"
                  rel="noreferrer"
                >
                  Baixe o kit grátis
                </a>
              </div> */}


            </div>
          </WrapperBlog>

          {filteredPosts?.length > 3.5 && (
            <Container>
              {filteredPosts?.map((post: PostModel, i) => {
                if (i >= 3.5) {
                  return <Post post={post} key={post.id} />;
                }

                return null;
              })}
            </Container>
          )}

          <Button
            style={{
              display: 'block',
              margin: '20px auto',
              color: '#2253f5',
              borderColor: '#2253f5'
            }}
            ref={loadMoreRef}
            disabled={noMorePosts}
          >
            {morePostsloading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : noMorePosts ? (
              'Sem mais posts'
            ) : (
              'Carregar mais'
            )}
          </Button>
        </>
      )}
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { preview, locale } = context;

  if (locale !== 'br') {
    return {
      notFound: true
    };
  }

  const { data } = await api.get('/posts', {
    params: {
      _embed: 1,
      per_page: 10,
      page: 1
    }
  });

  return {
    props: {
      ...(await serverSideTranslations(locale.toString())),
      posts: data,
      preview: preview || false
    }
  };
};

export default Posts;
